<template>
    <Transition v-if="showModalWithDelay && $appConfig.ENABLE_CAMPAIGNS" name="fade-slide">
        <div class="modal-wrapper-dark-background" @click.self="close">
            <div class="image-and-modal-container">
                <div v-if="popUp.imageUrl" class="image-bg-container">
                    <div class="image-container" :style="{background: `url(${popUp.imageUrl})`, 'background-size': 'cover', 'background-position': 'center'}">
                </div>
            </div>
            <div class="sale-modal">
                <div class="sale-modal__description">
                    <button name="close-btn" class="close-btn" @click="close">
                        <XCloseIcon />
                    </button>
                    <SaleTag :text="popUp.tagText" />
                    <h2>
                        {{ popUp.title }}
                    </h2>
                    <p v-html="popUp.bodyText">
                    </p>
                    <a
                        v-if="popUp.buttonUrl && popUp.button"
                        @click="getNow"
                        :href="popUp.buttonUrl"
                        class="btn-feedback-outlined"
                        target="_self"
                    >
                        {{ popUp.button }}
                        <ArrowRightIcon />
                    </a>
                    <a
                        href="javascript:void(0);"
                        @click="close"
                        style="
                            text-align: center;
                            font-weight: 600;
                            color: #3973b9;
                            font-size: 16px;
                        "
                        >{{ t('shared_close') }}
                    </a>
                </div>
            </div>
        </div>
        </div>
    </Transition>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import XCloseIcon from '@/assets/icons/XCloseIcon';
import ArrowRightIcon from '@/assets/icons/supportedCars/ArrowRightIcon';
import { useTranslation } from 'i18next-vue';
import SaleTag from '../SaleTag.vue';
import { facebookGoogleAnalitycs } from '@/utils/helpers';

const { t } = useTranslation(['shared', 'translation']);

const showModalWithDelay = ref(false);

const store = useStore();
const isMobile = computed(() => store.state.device.isMobile);
const isModalOpened = computed(() => store.state.modals?.isSaleModalOpen && store.state.campaign?.popUp?.title);

const popUp = computed(() => {
    const content = store.state.campaign?.popUp ?? {};
    const images = store.state.campaign?.images;
    const isMobileDevice = isMobile.value;

    return {
        title: isMobileDevice ? (content.titleMobile ?? content.title) : content.title,
        bodyText: isMobileDevice ? (content.bodyTextMobile ?? content.bodyText) : content.bodyText,
        tagText: isMobileDevice ? (content.tagMobile ?? content.tag) : content.tag,
        button: isMobileDevice ? (content.buttonMobile ?? content.button) : content.button,
        buttonUrl: content.buttonUrl,
        imageUrl: images?.length ? images[0].url : '',
    };
});

function close() {
    facebookGoogleAnalitycs('get_now_close_button');

    showModalWithDelay.value = false;
    store.dispatch('resetModalStates');
    document.body.classList.remove("overflow-hidden");
}

function getNow() {
    facebookGoogleAnalitycs('get_now');

    store.dispatch('resetModalStates');
}

onMounted(() => {
    setTimeout(() => {
        showModalWithDelay.value = isModalOpened.value;

        if (showModalWithDelay.value) {
            document.body.classList.add("overflow-hidden");
        }
    }, 3000);
})
</script>

<style lang="scss" scoped>
h2 {
    font-size: 32px;
    font-weight: 500;

    @media (max-width: $screen-md) {
        font-size: 24px;
    }
}

.image-and-modal-container {
    display: grid;

    .image-bg-container {
        height: 100%;
        width: 100%;
        background: $bg-dark-blue;
        border-radius: 24px 0 0 24px;

        .image-container {
            height: 100%;
            width: 100%;
        }
    }

    .sale-modal {
        border-radius: 24px;
    }

    &:has(.image-bg-container) {
        grid-template-columns: 1fr 1fr;

        .sale-modal {
            border-radius: 0px 24px 24px 0;
        }
    }

    @media (max-width: $screen-md) {
        display: flex;
        flex-direction: column;
        margin: 80px 32px 120px;

        .image-bg-container {
            margin-top: 40px;
            height: 360px;
            border-radius: 24px 24px 0 0;
        }


        &:has(.image-bg-container) {
            grid-template-columns: 1fr;
            grid-template-rows: 1fr 1fr;
            overflow: scroll;
            .sale-modal {
                border-radius: 0 0 24px 24px;
            }
        }
    }
}


</style>
